import { styled } from '@mui/material';

export const LogoStyled = styled('img')(({ theme }) => ({
  height: '100%',
  objectFit: 'contain',
  color: theme.palette.primaryDark.main,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  maxWidth: '100%',
  cusor: 'pointer',
}));
